export default {
  activeLanguage(state) {
    return state.localeModel.instance;
  },

  getActiveLanguageCode(state) {
    return state.localeModel.instance?.value;
  },

  languageList(state) {
    return state.localeList.instance;
  },
};
